import { useCallback, useEffect, useRef, useState } from 'react';

// Auto-rotating index over `count` slides; pauses while `pause()` is active.
export const useCarousel = (count, intervalMs = 6000) => {
  const [idx, setIdx] = useState(0);
  const paused = useRef(false);

  useEffect(() => {
    if (count < 2) return undefined;
    const t = setInterval(() => {
      if (!paused.current) setIdx((i) => (i + 1) % count);
    }, intervalMs);
    return () => clearInterval(t);
  }, [count, intervalMs]);

  const go = useCallback((n) => setIdx(((n % count) + count) % count), [count]);
  const pause = useCallback(() => { paused.current = true; }, []);
  const resume = useCallback(() => { paused.current = false; }, []);

  return { idx, go, pause, resume };
};
